import React, { useEffect, useState } from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
import { buyers } from '../data/buyers';
const FIRST_DELAY = 6000;
const VISIBLE_MS = 6000;
const GAP_MS = 9000;
export function PurchasePopup() {
  const [index, setIndex] = useState(0);
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  useEffect(() => {
    if (dismissed) return;
    let timeout = window.setTimeout(function show() {
      setVisible(true);
      timeout = window.setTimeout(() => {
        setVisible(false);
        timeout = window.setTimeout(() => {
          setIndex(prev => (prev + 1) % buyers.length);
          show();
        }, GAP_MS);
      }, VISIBLE_MS);
    }, FIRST_DELAY);
    return () => window.clearTimeout(timeout);
  }, [dismissed]);
  if (dismissed) return null;
  const buyer = buyers[index];
  return <div className="pointer-events-none fixed bottom-4 left-4 z-50 w-[calc(100%-2rem)] max-w-sm sm:bottom-6 sm:left-6" aria-live="polite" data-id="element-197" data-mp="1cvr4m2xq1anu">
      <div aria-hidden={!visible} className={`flex items-start gap-3 rounded-2xl border border-court-800 bg-court-950 p-4 shadow-[0_24px_60px_-20px_rgba(0,0,0,0.7)]
          transition-[opacity,transform] duration-[250ms] ease-smooth
          ${visible ? 'pointer-events-auto translate-y-0 scale-100 opacity-100' : 'translate-y-4 scale-[0.96] opacity-0'}`} data-id="element-198" data-mp="164oa074zg5up">
        <span className="mt-0.5 flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-ball" data-id="element-199" data-mp="n86av4nt13of">
          <CheckIcon className="h-5 w-5 text-court-950" strokeWidth={3} aria-hidden="true" data-id="element-200" data-mp="i93e07hza3rj" />
        </span>
        <div className="min-w-0 flex-1" data-id="element-201" data-mp="x62jnpt9rmjd">
          <p className="text-sm font-semibold leading-snug text-white" data-id="element-202" data-mp="s67t5ndeoyyu">
            {buyer.name} acaba de comprar Tenis 360™
          </p>
          <p className="mt-1 text-xs text-court-600" data-id="element-203" data-mp="28jes6dzz4tbv">
            <span className="text-ball" data-id="element-204" data-mp="28mara5nk5o1w">Libro digital</span> · {buyer.location} · hace{' '}
            {buyer.minutesAgo} min
          </p>
        </div>
        <button type="button" onClick={() => setDismissed(true)} tabIndex={visible ? 0 : -1} aria-label="Cerrar notificación de compra" className="-mr-1 -mt-1 rounded-full p-1.5 text-court-600 transition-colors duration-150 ease-smooth hover:bg-court-800 hover:text-white focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ball" data-id="element-205" data-mp="2anjlrmvdglaz">
          <XIcon className="h-4 w-4" aria-hidden="true" data-id="element-206" data-mp="1rzehmeasyybn" />
        </button>
      </div>
    </div>;
}